import { useQuery } from '@tanstack/react-query'
import { format } from 'date-fns'
import { ShieldCheck } from 'lucide-react'

import { listDmarcReports } from '../lib/api'

export default function Dmarc() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['dmarc'],
    queryFn: listDmarcReports,
  })

  const reports = (data?.reports || []).filter(r => r.pk?.startsWith('REPORT#'))

  return (
    <div className="h-full flex flex-col">
      <header className="border-b border-line px-6 py-5">
        <div className="h-eyebrow flex items-center gap-1.5"><ShieldCheck size={12} /> Deliverability</div>
        <h1 className="h-section">DMARC reports</h1>
        <p className="text-sm text-ink-500 mt-1">Aggregate reports arriving at dmarc@plustag.email — most recent 50.</p>
      </header>

      {isLoading && <div className="p-6 text-ink-500">Loading…</div>}
      {error && <div className="p-6 text-red-700">{error instanceof Error ? error.message : String(error)}</div>}

      <div className="overflow-auto p-4">
        <table className="w-full text-sm">
          <thead className="h-eyebrow">
            <tr className="border-b border-line">
              <th className="text-left px-3 py-2 font-medium">Window</th>
              <th className="text-left px-3 py-2 font-medium">Reporter</th>
              <th className="text-left px-3 py-2 font-medium">Domain</th>
              <th className="text-right px-3 py-2 font-medium">Total</th>
              <th className="text-right px-3 py-2 font-medium">Pass</th>
              <th className="text-right px-3 py-2 font-medium">Fail</th>
            </tr>
          </thead>
          <tbody>
            {reports.map((r, i) => (
              <tr key={i} className="border-b border-line/60 hover:bg-canvas">
                <td className="px-3 py-3 text-ink-700 whitespace-nowrap">
                  {r.date_range_begin ? format(new Date(Number(r.date_range_begin) * 1000), 'yyyy-MM-dd') : ''}
                </td>
                <td className="px-3 py-3 text-ink-900">{r.reporter_org}</td>
                <td className="px-3 py-3 font-mono text-xs text-ink-700">{r.policy_domain}</td>
                <td className="px-3 py-3 text-right text-ink-900">{r.total_count}</td>
                <td className="px-3 py-3 text-right text-emerald-700 font-medium">{r.pass_count}</td>
                <td className="px-3 py-3 text-right text-red-700 font-medium">{r.fail_count}</td>
              </tr>
            ))}
            {reports.length === 0 && !isLoading && (
              <tr><td colSpan={6} className="px-3 py-8 text-ink-500 text-center">
                No reports yet. Once your MX record points at SES and DMARC-monitoring
                reporters cycle (~18-36h), reports start landing here.
              </td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
